import axiosInstance from './axiosInstance'

const CANTON_TENANT_BASE = '/canton-tenant'

/**
 * Obtiene todas las asociaciones cantón-tenant
 * @param {Object} filters - Filtros opcionales (canton, tenant, habilitado)
 */
export const fetchCantonTenantRelations = async (filters = {}) => {
  try {
    const params = new URLSearchParams()
    if (filters.canton) params.append('canton', filters.canton)
    if (filters.tenant) params.append('tenant', filters.tenant)
    if (filters.habilitado !== undefined) params.append('habilitado', filters.habilitado)

    const url = params.toString()
      ? `${CANTON_TENANT_BASE}?${params.toString()}`
      : CANTON_TENANT_BASE

    const response = await axiosInstance.get(url)
    // Backend returns 'associations', frontend service was expecting 'relations'
    return response.data.associations || response.data.relations || response.data || []
  } catch (error) {
    console.error('Error fetching canton-tenant relations:', error)
    return []
  }
}

/**
 * Crea una nueva asociación cantón-tenant
 * @param {Object} data - { id_canton, id_tenant, orden, es_principal, habilitado }
 */
export const createCantonTenantRelation = async data => {
  try {
    const response = await axiosInstance.post(CANTON_TENANT_BASE, data)
    return {
      success: true,
      relation: response.data.association || response.data.relation || response.data
    }
  } catch (error) {
    console.error('Error creating canton-tenant relation:', error)
    return {
      success: false,
      message: error.response?.data?.message || 'Error al crear la asociación',
    }
  }
}

/**
 * Actualiza una asociación existente
 * @param {number} id - ID de la asociación
 * @param {Object} data - Datos a actualizar
 */
export const updateCantonTenantRelation = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${CANTON_TENANT_BASE}/${id}`, data)
    return {
      success: true,
      relation: response.data.association || response.data.relation || response.data
    }
  } catch (error) {
    console.error('Error updating canton-tenant relation:', error)
    return {
      success: false,
      message: error.response?.data?.message || 'Error al actualizar la asociación',
    }
  }
}

/**
 * Elimina una asociación
 * @param {number} id - ID de la asociación
 */
export const deleteCantonTenantRelation = async id => {
  try {
    await axiosInstance.delete(`${CANTON_TENANT_BASE}/${id}`)
    return { success: true }
  } catch (error) {
    console.error('Error deleting canton-tenant relation:', error)
    return {
      success: false,
      message: error.response?.data?.message || 'Error al eliminar la asociación',
    }
  }
}

/**
 * Establece una asociación como principal
 * @param {number} id - ID de la asociación
 */
export const setCantonTenantPrimary = async id => {
  try {
    const response = await axiosInstance.patch(`${CANTON_TENANT_BASE}/${id}/set-primary`)
    return {
      success: true,
      data: response.data.data // El backend devuelve { data: { id, es_principal } }
    }
  } catch (error) {
    console.error('Error setting primary relation:', error)
    return {
      success: false,
      message: error.response?.data?.message || 'Error al establecer como principal',
    }
  }
}
